module.exports = __webpack_public_path__ + "img/home-section-right-arrow.e55708b.png";